import { fetchDataFromBackend } from "../api/api";
import logger from "../core/utils/logger";

const isSimulation = import.meta.env.VITE_BACKEND_DATA_SIMULATION === "true";

export const LicenseService = {
    async getLicenseStatus() {
        try {
            if (isSimulation) {
                logger.log("Simulation mode active: Returning simulated license status.");
                return {
                    hasLicense: false,
                    maxUsers: 0,
                    validUntil: null,
                    currentUsers: 1,
                    status: "NoLicense",
                };
            }
            const response = await fetchDataFromBackend("/OrganizationSettings/licenseStatus", {
                skipAuth: false,
                method: "get",
            });
            logger.log("License status response:", response);
            return response;
        } catch (error) {
            logger.error("Error fetching license status:", error);
            throw error;
        }
    },

    async activateLicense(licenseKey) {
        try {
            if (isSimulation) {
                logger.log("Simulation mode active: Returning simulated activation success.");
                return {
                    hasLicense: true,
                    maxUsers: 5,
                    validUntil: "2099-12-31T00:00:00Z",
                    currentUsers: 1,
                    status: "Ok",
                };
            }
            const response = await fetchDataFromBackend("/OrganizationSettings/license", {
                skipAuth: false,
                method: "post",
                data: { licenseKey },
            });
            logger.log("Activate license response:", response);
            return response;
        } catch (error) {
            logger.error("Error activating license:", error);
            throw error;
        }
    },
};
